<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
// import Websocket from '@/network/websocket'
export default {
    name: 'App',
    created() {
        // console.log('运行环境：' + process.env.NODE_ENV)
        // console.log('61or62: ', process.env.VUE_APP_DOMAIN)
    },
    methods: {
        // openSocket() {
        //   let that = this
        //   let userToken = window.localStorage.getItem('userToken')
        //   let accessToken = window.localStorage.getItem('accessToken')
        //   let url = process.env.VUE_APP_WSS
        //   let ws = new Websocket(`${url}?userToken=${userToken}&Authorization=${accessToken}`)
        //   ws.onmessage = function (e) {
        //     let count = e.data.count
        //     if (count != 0) {
        //       that.$message('你有新的订阅通知!')
        //     }
        //     that.$root.$emit('message', Object.assign({}, e.data))
        //     that.$store.state.message = e.data
        //   }
        //   this.ws = ws
        // },
        closeSocket() {
            this.ws.close()
        }
    }
}
</script>
<style></style>
